export default __webpack_public_path__ + "static/media/prc_id.b7921abd.jpg";